export default __webpack_public_path__ + "static/media/logo.3d2c3901.svg";